import {
  IDestinationEntityHandler,
  type IDestination,
} from '@principle-theorem/practice-migrations/interfaces';
import { BaseDestinationHandler } from '../destination/base-destination-handler';
import { FeeScheduleDestinationEntity } from './destination/entities/fee-schedules';
import { PatientAppointmentDestinationEntity } from './destination/entities/patient-appointments';
import { PatientClinicalChartDestinationEntity } from './destination/entities/patient-clinical-charts';
import { PatientClinicalNoteDestinationEntity } from './destination/entities/patient-clinical-notes';
import { PatientDepositDestinationEntity } from './destination/entities/patient-deposits';
import { PatientFileDestinationEntity } from './destination/entities/patient-files';
import { PatientInteractionDestinationEntity } from './destination/entities/patient-interactions';
import { D4WPatientInvoiceDestinationEntity } from './destination/entities/patient-invoices';
import { PatientMediaSuiteFileDestinationEntity } from './destination/entities/patient-media-suite-files';
import { PatientRelationshipDestinationEntity } from './destination/entities/patient-relationships';
import { PatientTreatmentPlanDestinationEntity } from './destination/entities/patient-treatment-plans';
import { PatientDestinationEntity } from './destination/entities/patients';
import { StafferDestinationEntity } from './destination/entities/staff';
import { SterilisationRecordDestinationEntity } from './destination/entities/sterilisation-records';
import { PatientProfilePhotoDestinationEntity } from './destination/entities/patient-profile-photos';
import { ExistingPatientDestinationEntity } from './destination/entities/existing-patients';
import { D4WPatientMedicalHistoryDestinationEntity } from './destination/entities/patient-medical-history';
import { D4WSterilisationMachineDestinationEntity } from './destination/entities/sterilisation-machine';
import { D4WSterilisationEquipmentDestinationEntity } from './destination/entities/sterilisations-equipment';
import { D4WSterilisationCycleDestinationEntity } from './destination/entities/sterilisation-cycle';
import { UnusedSterilisationRecordDestinationEntity } from './destination/entities/unused-sterilisation-records';

export const D4W_DESTINATION: IDestination = {
  metadata: {
    name: 'Principle Firestore',
    description: 'Main Principle Migration',
  },
  configuration: [],
};

export class D4WDestinationHandler extends BaseDestinationHandler {
  migrationType = 'D4W';
  migrationVersion = 'v1';
  destination = D4W_DESTINATION;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entityHandlers: IDestinationEntityHandler<any, any, any>[] = [
    new PatientDestinationEntity(),
    new FeeScheduleDestinationEntity(),
    new StafferDestinationEntity(),
    new PatientInteractionDestinationEntity(),
    new PatientClinicalChartDestinationEntity(),
    new PatientClinicalNoteDestinationEntity(),
    new PatientTreatmentPlanDestinationEntity(),
    new PatientAppointmentDestinationEntity(),
    new SterilisationRecordDestinationEntity(),
    new D4WPatientInvoiceDestinationEntity(),
    new PatientRelationshipDestinationEntity(),
    new PatientFileDestinationEntity(),
    new PatientMediaSuiteFileDestinationEntity(),
    new PatientDepositDestinationEntity(),
    new PatientProfilePhotoDestinationEntity(),
    new ExistingPatientDestinationEntity(),
    new D4WPatientMedicalHistoryDestinationEntity(),
    new D4WSterilisationMachineDestinationEntity(),
    new D4WSterilisationEquipmentDestinationEntity(),
    new D4WSterilisationCycleDestinationEntity(),
    new UnusedSterilisationRecordDestinationEntity(),
  ];
}
